import { Fragment } from "react"
import { Outlet } from "react-router-dom"

const OperationsWrapper = () => {

    return (
        <Fragment>
            <Outlet/>
        </Fragment>
    )
}

export default OperationsWrapper